import { ServiceRecords } from '@/service/records/serviceRecords'

const recordsService = new ServiceRecords()

export default {
  namespaced: true,
  state: {
    loading: false,
    records: [],
    record: {},
    recordExists: false,
    refresh: false,
    meta: {
      page: 1,
      pageSize: 5,
      total: 0,
    },
  },
  mutations: {
    setRecords(state, { records, meta }) {
      state.records = records
      state.meta = meta
    },
    setRecord(state, record) {
      state.record = record
    },
    setRecordExists(state, exists) {
      state.recordExists = exists
    },
    setLoading(state, loading) {
      state.loading = loading
    },
  },
  actions: {
    async fetchRecordsAll({ commit }, query = {}) {
      commit('setLoading', true)
      try {
        const response = await recordsService.recordsAll(query)
        commit('setRecords', { records: response.data, meta: response.meta })
        commit('setLoading', false)
        return response
      } catch (error) {
        console.error('Erro ao buscar todos os registros:', error)
        commit('setLoading', false)
        throw error
      }
    },
    async recordCreate({ state }, data) {
      try {
        const response = await recordsService.recordCreate(data)
        state.refresh = !state.refresh
        return response.data
      } catch (error) {
        console.error('Erro ao criar registro:', error)
        throw error
      }
    },
    async recordById({ commit }, id) {
      try {
        const response = await recordsService.recordById(id)

        commit('setRecord', response)
        return response
      } catch (error) {
        console.error('Erro ao buscar registro:', error)
        throw error
      }
    },
    async checkRecordExists({ commit }, { custumer_id }) {
      try {
        const response = await recordsService.checkRecordExists(custumer_id)
        commit('setRecordExists', !!response)
        commit('setRecord', response)
        return response
      } catch (error) {
        console.error('Erro ao verificar registro existente:', error)
        throw error
      }
    },
    async recordUpdate({ state }, payload) {
      try {
        const response = await recordsService.recordUpdate(payload.recordId, { status: payload.status })
        state.refresh = !state.refresh
        return response.data
      } catch (error) {
        console.error('Erro ao atualizar registro:', error)
        throw error
      }
    },
  },
  getters: {
    getRecords: state => state.records,
    getRecord: state => state.record,
    recordExists: state => state.recordExists,
    getMeta: state => state.meta,
  },
}
